import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StorageService } from '../_services';
import { DataService } from '../_services/data.service';

@Component({
  selector: 'app-summary-requestitem',
  templateUrl: './summary-requestitem.component.html',
  styleUrls: [
    './summary-requestitem.component.css',
    "./custom_style.css",
    "./boot-outline-btn.css"
  ]
})
export class SummaryRequestitemComponent implements OnInit {

  @Input("request") request: any;
  @Input("from_loan") from_loan = true;
  @Output() loadRequest = new EventEmitter();
  @Output() loadPortfolio = new EventEmitter();
  @Input("loading") loading = false;
  @Input("active") active = false;
  request_loading = false;
  currentUser: any;
  showoff = false;
  lender: any;
  
  constructor(
    private dataService: DataService,
    private storageService: StorageService
  ) { 
    this.dataService.onRequestLoadingFromBackend.subscribe((res) => {
      this.loading = false;
    });
    this.dataService.onRequestLoadingEndFromBackend.subscribe((res) => {
      this.loading = false;
    });
    this.currentUser = this.storageService.read<any>("currentUser");
    this.lender = this.storageService.read<any>("platform");
    this.showoff = this.currentUser.showoff ? this.currentUser.showoff : false;
  }

  ngOnInit() {}

  openLoan(request) {
    this.loadRequest.emit({ request: request });
    this.loadPortfolio.emit({ request: request });
  }

}
